import React from 'react';
import type { Nullable } from 'corgi-types';

import { useLocalization } from 'common/providers/LocaleProvider';
import type { ReclamationSolution } from 'common/types/reclamation';
import AlertForNoContentStep from '../AlertForNoContentStep';
import EditSolutionButton from './EditSolutionButton';
import SolutionSection from './SolutionSection';

export interface SolutionProps {
  isDisabled: boolean;
  solution?: Nullable<ReclamationSolution>;
  onEdit?: () => void;
}

const Solution = ({ solution, isDisabled, onEdit }: SolutionProps) => {
  const { t } = useLocalization();

  return (
    <>
      {!!onEdit ? (
        <EditSolutionButton solution={solution} isDisabled={isDisabled} onClick={onEdit} />
      ) : (
        <SolutionSection solution={solution} />
      )}
      {!solution && (
        <AlertForNoContentStep textContent={t('h24_please_insert_solution_for_request')} />
      )}
    </>
  );
};

export default Solution;
